import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { UsuarioMantenimiento } from "../../models/usuario-mantenimiento";
import { endpointsURL } from "src/app/constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class MaintenanceUserService {
  env = environment.env;
  usuarioMantenimientoURL = endpointsURL.usuarioMantenimientoURL;
  downloadReportURL = endpointsURL.downloadReportURL;

  constructor(private httpClient: HttpClient) {}

  public list(filters: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.usuarioMantenimientoURL}/edit/lista${filters}`
    );
  }

  public createUser(user: UsuarioMantenimiento): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.env}${this.usuarioMantenimientoURL}/edit`,
      user
    );
  }

  public editUser(
    user: UsuarioMantenimiento,
    userId: string
  ): Observable<any[]> {
    return this.httpClient.put<any[]>(
      `${this.env}${this.usuarioMantenimientoURL}/edit`,
      user
    );
  }

  public getUsuario(userFilter: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.usuarioMantenimientoURL}/edit${userFilter}`
    );
  }

  public deleteUsuario(ids: string[]): Observable<any> {
    let params = new HttpParams();

    ids.forEach((e) => {
      params = params.append("_id", e);
    });
    return this.httpClient.delete<any>(
      `${this.env}${this.usuarioMantenimientoURL}/edit`,
      {
        params: params,
      }
    );
  }

  public downloadReport(): Observable<any> {
    return this.httpClient.get(
      `${this.env}${this.downloadReportURL}report/users`,
      {
        responseType: "blob",
      }
    );
  }
}
